_.mixin(window.written)

_.mixin
  trim: (str) ->
    if typeof str is "string" then str.replace(/(^\s+|\s+$)/g, "") else str
